"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const common_utils_1 = require("@zapier/common-utils");
const DEFAULT_EXPIRE = 1000 * 60 * 60 * 24 * 365 * 100;
const getValue = (input) => {
    let itemArray;
    try {
        itemArray = JSON.parse(input);
    }
    catch (_a) {
        return [null, true];
    }
    if (!itemArray.length || itemArray.length < 2) {
        return [null, true];
    }
    const expired = itemArray[0] < new Date().getTime();
    if (expired) {
        return [null, expired];
    }
    let value;
    try {
        value = JSON.parse(itemArray[1]);
    }
    catch (_b) {
        value = itemArray[1];
    }
    return [value, false];
};
const store = {
    length: () => window.localStorage.length,
    remove: (...args) => window.localStorage.removeItem(...args),
    clear: (...args) => window.localStorage.clear(...args),
    get: key => {
        const item = window.localStorage.getItem(key);
        if (!item) {
            return null;
        }
        const [value, expired] = getValue(item);
        if (expired) {
            store.remove(key);
        }
        return value;
    },
    set: (key, val, options = {}) => {
        let expire = common_utils_1.get(options, 'expire', DEFAULT_EXPIRE);
        if (!common_utils_1.exists(expire)) {
            expire = DEFAULT_EXPIRE;
        }
        expire += new Date().getTime();
        if (lodash_1.isObject(val)) {
            val = JSON.stringify(val);
        }
        try {
            window.localStorage.setItem(key, JSON.stringify([expire, val]));
        }
        catch (_a) {
        }
    },
};
exports.default = store;
